import {Pipe, PipeTransform} from '@angular/core';
import {Team} from "@team/model";

@Pipe({
  name: 'teamFormat'
})
export class TeamFormatPipe implements PipeTransform {
  transform(value: Team): string {
    if (!value.isStructural) {
      return value.name;
    }

    let str = value.name;
    let parent = value.parent;

    while (parent) {
      //Old fonction - affiche le parent de la team.
      //str = `${parent.name} / ${str}`;

      str = `${str}`;
      parent = parent.parent;
    }

    return str;
  }
}
